import { createReducer } from 'typesafe-actions';

import { IWebhookState, TWebhookAction, WebhookActionTypes } from '@/features/webhooks/webhook.types';

const initialState: IWebhookState = {
  webhooks: [],
  isLoading: false,
};

export const webhookReducer = createReducer<IWebhookState, TWebhookAction>(initialState)
  .handleType(WebhookActionTypes.SEARCH_WEBHOOKS, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(WebhookActionTypes.SEARCH_WEBHOOKS_SUCCESS, (state, action) => ({
    ...state,
    webhooks: action.webhooks,
    isLoading: false,
    error: undefined,
  }))

  .handleType(WebhookActionTypes.SEARCH_WEBHOOKS_FAIL, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  }))

  .handleType(WebhookActionTypes.ADD_WEBHOOK, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(WebhookActionTypes.ADD_WEBHOOK_SUCCESS, (state, action) => ({
    ...state,
    webhooks: [...state.webhooks, action.webhook],
    isLoading: false,
    error: undefined,
  }))

  .handleType(WebhookActionTypes.ADD_WEBHOOK_FAIL, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  }))

  .handleType(WebhookActionTypes.UPDATE_WEBHOOK, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(WebhookActionTypes.UPDATE_WEBHOOK_SUCCESS, (state, action) => {
    const webhooks = state.webhooks;
    let updatedWebhooks = [action.webhook];

    if (webhooks && webhooks.length) {
      updatedWebhooks = webhooks.map((webhook) => (webhook.uuid === action.webhook.uuid ? action.webhook : webhook));
    }

    return {
      ...state,
      webhooks: updatedWebhooks,
      isLoading: false,
      error: undefined,
    };
  })

  .handleType(WebhookActionTypes.UPDATE_WEBHOOK_FAIL, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  }))

  .handleType(WebhookActionTypes.REMOVE_WEBHOOK, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(WebhookActionTypes.REMOVE_WEBHOOK_SUCCESS, (state, action) => ({
    ...state,
    webhooks: state.webhooks.filter((webhook) => webhook.uuid !== action.webhookId),
    isLoading: false,
    error: undefined,
  }))

  .handleType(WebhookActionTypes.REMOVE_WEBHOOK_FAIL, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  }));
